import { render, staticRenderFns } from "./NavigationSimple.vue?vue&type=template&id=56a49ec8&"
import script from "./NavigationSimple.vue?vue&type=script&lang=ts&"
export * from "./NavigationSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports